import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.map";
import "regenerator-runtime/runtime";
import _get from "lodash/get";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { createAsyncAction } from "../../../actions/utils";
import { GET_MONEY_TRANSFER_ACCOUNT_ELIGIBILITY, GET_MONEY_MANAGEMENT_ACCOUNTS } from "../../../lib/queries/money-management";
/**
 * Money Management API
 */

export var createMoneyManagementTransfer = createAsyncAction('createMoneyManagementTransfer', function (params) {
  var serverRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.MoneyManagementSDK.createTransfer(params, serverRequest, config);
    }
  };
});
export var createMoneyManagementAccount = createAsyncAction('createMoneyManagementAccount', function (data) {
  var serverRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.MoneyManagementSDK.createFinancialAccount(data, serverRequest, config);
    }
  };
});
export var fetchMoneyManagementTransferLimits = createAsyncAction('fetchMoneyManagementTransferLimits', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.MoneyManagementSDK.getTransferLimits();
    }
  };
}); // Create a user in the money management system

export var createMoneyManagementUser = createAsyncAction('createMoneyManagementUser', function (data) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.MoneyManagementSDK.createUser(data);
    }
  };
});
export var createMoneyManagementUserWithKba = createAsyncAction('createMoneyManagementUserWithKba', function (data) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.MoneyManagementSDK.createUserWithKba(data);
    }
  };
}); // Get all financial accounts for the current user

export var fetchAllMoneyManagementAccounts = createAsyncAction('fetchAllMoneyManagementAccounts', function () {
  return {
    makeRequest: function () {
      var _makeRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_state, _ref) {
        var apolloClient, moneyManagementAccountsQuery, moneyManagementAccountsQueryData, accounts;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apolloClient = _ref.apolloClient;
                _context.next = 3;
                return apolloClient.query({
                  query: GET_MONEY_MANAGEMENT_ACCOUNTS,
                  fetchPolicy: 'network-only'
                });

              case 3:
                moneyManagementAccountsQuery = _context.sent;
                moneyManagementAccountsQueryData = _get(moneyManagementAccountsQuery, 'data.moneyTransferAccounts', {});
                accounts = _get(moneyManagementAccountsQueryData, 'accounts', []).map(function (moneyManagementAccount) {
                  return {
                    model: {
                      financial_account_id: moneyManagementAccount.financialAccountId,
                      financial_account_last_4: moneyManagementAccount.financialAccountLastFour,
                      financial_account_name: moneyManagementAccount.institutionName,
                      financial_account_type: moneyManagementAccount.financialAccountType,
                      id: moneyManagementAccount.id,
                      name_match_success: moneyManagementAccount.nameMatchSuccess
                    },
                    status: moneyManagementAccount.computedStatus
                  };
                });
                return _context.abrupt("return", {
                  items: accounts,
                  maxAccountsPerUser: moneyManagementAccountsQueryData.maxAccountsPerUser,
                  numAccountsLeftToAdd: moneyManagementAccountsQueryData.numAccountsLeftToAdd
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function makeRequest(_x, _x2) {
        return _makeRequest.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
}); // Get the account eligibility information for a financial account state id

export var fetchMoneyManagementAccountEligibilityForProviderAccount = createAsyncAction('fetchMoneyManagementAccountEligibilityForProviderAccount', function (data) {
  return {
    makeRequest: function () {
      var _makeRequest2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(state, _ref2) {
        var apolloClient, moneyTransferAccountEligibilityResponse, moneyTransferEligibilityForAccounts;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                apolloClient = _ref2.apolloClient;
                _context2.next = 3;
                return apolloClient.query({
                  query: GET_MONEY_TRANSFER_ACCOUNT_ELIGIBILITY,
                  variables: {
                    financialPortalId: data.financial_account_state_id
                  },
                  fetchPolicy: 'network-only'
                });

              case 3:
                moneyTransferAccountEligibilityResponse = _context2.sent;
                moneyTransferEligibilityForAccounts = _get(moneyTransferAccountEligibilityResponse, 'data.moneyTransferAccountEligibility.accounts', []);
                return _context2.abrupt("return", {
                  items: moneyTransferEligibilityForAccounts.map(function (eligibilityForAccount) {
                    return {
                      id: eligibilityForAccount.id,
                      eligibility: eligibilityForAccount.eligibility,
                      financial_account_type: eligibilityForAccount.financialAccountType
                    };
                  })
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function makeRequest(_x3, _x4) {
        return _makeRequest2.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
}); // Get a user of the money management system

export var fetchMoneyManagementUser = createAsyncAction('fetchMoneyManagementUser', function () {
  return {
    makeRequest: function () {
      var _makeRequest3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(state, opts) {
        var statusCode;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return opts.MoneyManagementSDK.getUser();

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                statusCode = _get(_context3.t0, 'resp.statusCode');

                if (!(statusCode === 404)) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return", {});

              case 11:
                throw _context3.t0;

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 6]]);
      }));

      function makeRequest(_x5, _x6) {
        return _makeRequest3.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
});
export var fetchMoneyManagementKbaQuestions = createAsyncAction('fetchMoneyManagementKbaQuestions', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.MoneyManagementSDK.getKbaQuestions();
    }
  };
}); // Get all transfers for the current user

export var fetchAllMoneyManagementTransfers = createAsyncAction('fetchAllMoneyManagementTransfers', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.MoneyManagementSDK.getAllTransfers();
    }
  };
}); // Get a transfer for the current user by ID

export var fetchMoneyManagementTransfer = createAsyncAction('fetchMoneyManagementTransfer', function (data) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.MoneyManagementSDK.getTransfer(data);
    }
  };
}); // Cancel a transfer for the current user by ID

export var cancelMoneyManagementTransfer = createAsyncAction('cancelMoneyManagementTransfer', function (data) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.MoneyManagementSDK.cancelTransfer(data);
    }
  };
});